module.exports = __webpack_public_path__ + "05e594e72a831f0226838fb4b664a417.svg";